var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lockscreen"},[_c('canvas',{attrs:{"id":"mycanvas","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }